'use strict';

import { EventDebouncer, EventDebouncerAnimationFrame } from '../modules/event-debouncer.js';

;(function($)
{
	$.fn.productSlider = function()
	{	//2019-02-18
		$(this).each(function()
		{
			var itemContainer = $(this);
			
			var _this = this;
			
			this.productContainer = null;
			this.containerWidth = 0;
			this.itemWidth = 0;
			this.items = null;
			this.numItemsInViewport = 0;
			this.maxLeft = 0;
			this.minLeft = 0;
			this.currentLeft = 0;
			this.currentIndex = 0;
			this.touchMoving = false;
			this.snapThreshold = 25;
			this.backSlider = $('<div class="backSlider icon icon-angle-left"></div>');
			this.forwardSlider = $('<div class="forwardSlider icon icon-angle-right"></div>');
			this.isTransitioning = false;
			
			this.initialize = function()
			{
				itemContainer.addClass('productSlider');
				
				itemContainer.children().wrapAll('<div class="productContainer" />');
				this.productContainer = itemContainer.find('.productContainer');
				
				this.backSlider.click(function()
				{
					if(!_this.touchMoving) _this.back();
				});
				
				this.forwardSlider.click(function()
				{
					if(!_this.touchMoving) _this.forward();
				});
				
				itemContainer.prepend(this.backSlider);
				itemContainer.append(this.forwardSlider);
				
				this.calculate();
				
				this.touchMoving = false;
				
				this.setLeft(this.currentLeft);
				
				$(window).on('bm:bsDeviceChange', function()
				{
					_this.calculate();
					_this.setLeft(_this.minMaxLeft(-(_this.itemWidth * _this.currentIndex)));
				});
				
				$(this).on('touchstart', this.touchStart);
				$(this).on('touchmove', this.touchMove);
				$(this).on('touchend', this.touchEnd);
			}
			
			this.setLeft = function(newLeft, animate)
			{	//2019-02-18
				if(this.isTransitioning) return;
				
				animate = animate || false;
				
				if(this.isAtEnd() && newLeft < this.minLeft)
				{
					var children = this.productContainer.children();
					var firstItem = $(children[0]);
					
					newLeft += this.itemWidth;
					originalLeft += this.itemWidth;
					
					if(!this.touchMoving)
					{
						setTimeout(function()
						{
							_this.setLeft(_this.minLeft, true);
						}, 20);
						
						newLeft += this.itemWidth;
						animate = false;
					}
					
					this.productContainer.append(firstItem);
				}
				else if(this.isAtStart() && newLeft > this.maxLeft)
				{
					var children = this.productContainer.children();
					var lastItem = $(children[children.length-1]);
					
					newLeft -= this.itemWidth;
					originalLeft -= this.itemWidth;
					
					if(!this.touchMoving)
					{
						setTimeout(function()
						{
							_this.setLeft(_this.maxLeft, true);
						}, 20);
						
						newLeft -= this.itemWidth;
						animate = false;
					}
					
					this.productContainer.prepend(lastItem);
				}
				
				this.currentLeft = this.minMaxLeft(newLeft);
				
				if(animate)
				{
					this.productContainer.addClass('slideTransition');
					this.isTransitioning = true;
					
					setTimeout(function()
					{
						_this.isTransitioning = false;
					}, parseFloat(getComputedStyle(_this.productContainer.get(0))['transitionDuration'])* 1000);
				}
				else
				{
					this.productContainer.removeClass('slideTransition');
				}
				
				this.productContainer.css('transform', 'translateX('+this.currentLeft+'%)');
			};
			
			this.minMaxLeft = function(value)
			{
				return Math.min(this.maxLeft, Math.max(this.minLeft, value));
			}
			
			this.calculate = function()
			{	//2019-02-18
				this.items = this.productContainer.children();
				this.containerWidth = parseInt(itemContainer.outerWidth(), 10);
				this.itemWidth = (this.items.outerWidth() / this.containerWidth) * 100;
				this.numItemsInViewport = (Math.floor(100/this.itemWidth));
				this.minLeft = -(this.itemWidth * this.items.length) + 100;
			};
			
			this.forward = function(steps)
			{	//2019-02-18
				steps = steps || 1;
				
				if(!this.isTransitioning) this.currentIndex = Math.min(this.currentIndex + steps, this.items.length - this.numItemsInViewport);
				
				this.setLeft((this.currentLeft-this.itemWidth*steps), true);
			};
			
			this.back = function(steps)
			{	//2019-02-18
				steps = steps || 1;
				
				if(!this.isTransitioning) this.currentIndex = Math.max(this.currentIndex - steps, 0);
				
				this.setLeft((this.currentLeft+this.itemWidth*steps), true);
			};
			
			this.isAtStart = function()
			{	//2019-02-18
				var isAtStart = (this.currentLeft === this.maxLeft);
				
				itemContainer[isAtStart?'addClass':'removeClass']('isAtStart');
				
				return isAtStart;
			};
			
			this.isAtEnd = function()
			{	//2019-02-18
				var isAtEnd = (this.currentLeft === this.minLeft);
				
				itemContainer[isAtEnd?'addClass':'removeClass']('isAtEnd');
				
				return isAtEnd;
			};
			
			this.scrollToStart = function()
			{	//2019-02-18
				this.currentIndex = 0;
				this.setLeft(this.maxLeft, true);
			};
			
			this.scrollToEnd = function()
			{	//2019-02-18
				this.currentIndex = this.items.length - Math.floor(100 / this.itemWidth);
				this.setLeft(this.minLeft, true);
			};
			
			var startX = 0;
			var xDiff = 0;
			
			var startY = 0;
			var yDiff = 0;
			
			var originalLeft = 0;
			var threshold = 1;
			
			var scrollby = false;
			var scrollbyIsset = false;
			
			var moveDebouncer = new EventDebouncerAnimationFrame(function()
			{
				if(_this.touchMoving) _this.setLeft(originalLeft - xDiff);
			});
			
			var productContainerWidth = 0;
			var windowHeight = 0;
			
			this.touchStart = function(e)
			{
				if(!this.touchMoving)
				{
					xDiff = 0;
					yDiff = 0;
					startX = e.touches[0].clientX;
					startY = e.touches[0].clientY;
					originalLeft = this.currentLeft;
					threshold = (this.snapThreshold/100 * this.itemWidth);
					scrollbyIsset = false;
					scrollby = false;
					
					productContainerWidth = this.productContainer.outerWidth();
					windowHeight = $(window).outerHeight();
				}
			};
			
			this.touchMove = function(e)
			{
				if(scrollbyIsset === false)
				{
					var radian = Math.abs(Math.atan((e.touches[0].clientY - startY) / (e.touches[0].clientX - startX)));
					scrollby = ((360 / (2 * Math.PI)) * radian > 45); //converting radians into degrees, and checking if the angle is over 45 degrees (1 radian = 57.3 degrees)
					scrollbyIsset = true;
				}
				
				if(scrollby === false)
				{
					this.touchMoving = true;
					xDiff = (startX - e.touches[0].clientX) / productContainerWidth * 100;
					yDiff = (startY - e.touches[0].clientY) / windowHeight * 100;
					e.preventDefault();
					moveDebouncer.event();
				}
			};
			
			this.touchEnd = function(e)
			{
				if(!this.touchMoving) return;
				
				this.currentLeft = originalLeft;
				
				var extraIndex = Math.max(0, Math.floor(((Math.abs(xDiff)/this.itemWidth)*100 + 50)/100));
				
				if(xDiff < -threshold)
				{
					this.back(extraIndex);
				}
				else if(xDiff > threshold)
				{
					this.forward(extraIndex);
				}
				else
				{
					this.setLeft(originalLeft, true);
				}
				
				this.touchMoving = false;
			};
			
			this.initialize();
		});
	}
})(jQuery);